var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.message.action_key === 'payment_confirmation')?_c('ActionPaymentConfirmation',{attrs:{"message":_vm.message}}):_vm._e(),(_vm.message.action_key === 'payment_confirmation_check')?_c('ActionPaymentConfirmationCheck',{attrs:{"message":_vm.message}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }